import Highcharts from "highcharts";

const light = (Highcharts.theme = {
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: "",
    style: {
      fontFamily: "'Lato', 'Honeywell Sans Web', Arial,Helvetica,sans-serif",
    },
    plotBorderColor: "#606063",
  },
  title: {
    align: "center",
    style: {
      color: "black",
      textTransform: "capitalize",
      fontSize: "18px",
      fontWeight: "700",
      left: "10px",
    },

  },
  subtitle: {
    style: {
      color: "#000000",
      textTransform: "uppercase",
    },
  },
  xAxis: {
    gridLineColor: "#404040",
    labels: {
      style: {
        color: "#000000",
      },
    },
    lineColor: "#000000",
    minorGridLineColor: "#505053",
    tickColor: "#707073",
    title: {
      style: {
        color: "#000000",
      },
    },
  },
  yAxis: {
    gridLineColor: "#404040",
    labels: {
      style: {
        color: "#000000",
      },
    },
    lineColor: "#000000",
    minorGridLineColor: "#505053",
    tickColor: "#707073",
    // tickWidth: 1,
    title: {
      style: {
        color: "#000000",
      },
    },
  },
  legend: {
    backgroundColor: "",

    itemStyle: {
      color: "#000",
    },
    itemHoverStyle: {
      color: "#000",
    },
    itemHiddenStyle: {
      color: "#606063",
    },
    title: {
      style: {
        color: "#C0C0C0",
      },
    },

    align: "left",
    verticalAlign: "top",
    // itemDistance: 15,
    // itemMarginBottom: 5,
    // padding: 0,
    // margin: 20,
    x: 80,
    y: 0,
    floating: false,
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    borderColor: "black",

    series: {
      dataLabels: {
        color: "#F0F0F3",
        style: {
          fontSize: "13px",
        },
      },
      marker: {
        lineColor: "#333",
      },
      // events: {
      //   legendItemClick: function(event) {
      //       return !(this.name == 'Planner Recommended')&& !(this.name == 'Census Headcount')
      //       && !(this.name == 'Hours Available') && !(this.name == 'Capacity') && !(this.name == 'DLE')  ;

      //   },

      // }
    },
    boxplot: {
      fillColor: "#505053",
    },
    candlestick: {
      lineColor: "white",
    },
    errorbar: {
      color: "white",
    },
  },
});
/*****
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const dark = (Highcharts.theme = {
  colors: [
    "#2b908f",
    "#90ee7e",
    "#f45b5b",
    "#7798BF",
    "#aaeeee",
    "#ff0066",
    "#eeaaee",
    "#55BF3B",
    "#DF5353",
    "#7798BF",
    "#aaeeee",
  ],
  chart: {
    backgroundColor: "",
    style: {
      fontFamily: "'Lato', 'Honeywell Sans Web', Arial,Helvetica,sans-serif",
    },
    plotBorderColor: "#606063",
  },
  title: {
    align: "center",
    style: {
      color: "grey",
      textTransform: "capitalize",
      fontSize: "18px",
      fontWeight: "700",
      left: "10px",
    },
  },
  subtitle: {
    style: {
      color: "#E0E0E3",
      textTransform: "uppercase",
    },
  },
  xAxis: {
    gridLineColor: "#707073",
    lineWidth: 2,

    labels: {
      style: {
        color: "#FFFFFF",
      },
    },
    lineColor: "#FFFFFF",
    minorGridLineColor: "#505053",
    tickColor: "#707073",
    title: {
      style: {
        color: "#A0A0A3",
      },
    },
  },
  yAxis: {
    gridLineColor: "",

    labels: {
      style: {
        color: "#FFFFFF",

      },
    },
    lineColor: "#FFFFFF",
    minorGridLineColor: "#505053",
    tickColor: "#707073",
    lineWidth: 2,
    title: {
      style: {
        color: "#8f8f8f",
      },
    },
  },
  tooltip: {
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    style: {
      color: "#F0F0F0",
    },
  },
  plotOptions: {
    borderColor: "black",

    series: {
      dataLabels: {
        color: "#F0F0F3",
        style: {
          fontSize: "13px",
        },
      },
      marker: {
        lineColor: "#333",
      },
      // events: {
      //   legendItemClick: function(event) {
      //       return !(this.name == 'Planner Recommended')&& !(this.name == 'Census Headcount')
      //       && !(this.name == 'Hours Available') && !(this.name == 'Capacity') && !(this.name == 'DLE')  ;

      //   },

      // }
    },
    boxplot: {
      fillColor: "#505053",
    },
    candlestick: {
      lineColor: "white",
    },
    errorbar: {
      color: "white",
    },
  },
  legend: {
    backgroundColor: "",

    itemStyle: {
      color: "#E0E0E3",
    },
    itemHoverStyle: {
      color: "#FFF",
    },
    itemHiddenStyle: {
      color: "#606063",
    },
    title: {
      style: {
        color: "#C0C0C0",
      },
    },

    align: "left",
    verticalAlign: "top",
    // itemDistance: 15,
    // itemMarginBottom: 5,
    // padding: 0,
    // margin: 20,
    x: 80,
    y: 0,
    floating: false,
  },
  credits: {
    enabled: false,
  },
  labels: {
    style: {
      color: "#707073",
    },
  },
  drilldown: {
    activeAxisLabelStyle: {
      color: "#F0F0F3",
    },
    activeDataLabelStyle: {
      color: "#F0F0F3",
    },
  },
  navigation: {
    buttonOptions: {
      // symbolStroke: "#DDDDDD",
      theme: {
        fill: "#505053",
      },
    },
  },
  // scroll charts
  rangeSelector: {
    buttonTheme: {
      fill: "#505053",
      stroke: "#000000",
      style: {
        color: "#CCC",
      },
      states: {
        hover: {
          fill: "#707073",
          stroke: "#000000",
          style: {
            color: "white",
          },
        },
        select: {
          fill: "#000003",
          stroke: "#000000",
          style: {
            color: "white",
          },
        },
      },
    },
    inputBoxBorderColor: "#505053",
    inputStyle: {
      backgroundColor: "#333",
      color: "silver",
    },
    labelStyle: {
      color: "silver",
    },
  },
  navigator: {
    handles: {
      backgroundColor: "#666",
      borderColor: "#AAA",
    },
    outlineColor: "#CCC",
    maskFill: "rgba(255,255,255,0.1)",
    series: {
      color: "#7798BF",
      lineColor: "#A6C7ED",
    },
    xAxis: {
      gridLineColor: "#505053",
    },
  },
  scrollbar: {
    barBackgroundColor: "#808083",
    barBorderColor: "#808083",
    buttonArrowColor: "#CCC",
    buttonBackgroundColor: "#606063",
    buttonBorderColor: "#606063",
    rifleColor: "#FFF",
    trackBackgroundColor: "#404043",
    trackBorderColor: "#404043",
  },
});

const HighchartsTheme = {
  light,
  dark,
};

export default HighchartsTheme;
